import * as React from 'react'
import { Input } from '@mds/mds-reactjs-library'
import Glyph32BEye from '@mds/mds-icons/icons/svg/glyph-32-b-eye.svg'
import Glyph32Eye from '@mds/mds-icons/icons/svg/glyph-32-eye.svg'
import './PasswordWithToggle.css'

type PasswordWithToggleProps = React.ComponentProps<typeof Input> & {
  buttonProps: {
    value: string
    showPassword: boolean
    onToggle: () => void
  }
}

const PasswordWithToggle = React.memo(({ buttonProps, ...inputProps }: PasswordWithToggleProps) => {
  const { value, showPassword, onToggle } = buttonProps

  return (
    <div className="password-toggle-wrapper">
      <Input {...inputProps} />
      {value && (
        <button type="button" className="password-toggle-button" onClick={onToggle}>
          <img src={showPassword ? Glyph32Eye : Glyph32BEye} alt={showPassword ? 'Show password' : 'Hide password'} />
        </button>
      )}
    </div>
  )
})

PasswordWithToggle.displayName = 'PasswordWithToggle'

export default PasswordWithToggle
export type { PasswordWithToggleProps }
